import { CASA_LEON_WEATHER_SITE } from './location.js';

export function formatInMendoza(iso: string, opts: Intl.DateTimeFormatOptions): string {
  return new Intl.DateTimeFormat('es-AR', { timeZone: CASA_LEON_WEATHER_SITE.timezone, ...opts }).format(
    new Date(iso),
  );
}
